import { connect } from "react-redux";

import Footer from "./Footer";

const mapStateToProps = state => ({
  showLightVersion: state.showLightVersion
});

export default connect(mapStateToProps)(Footer);
